<div class="row">
  <ng-container *ngIf="!somenteVisualizar">
    <div class="col-12">
      <form [formGroup]="entidadeSuperioresForm" id="entidadeSuperioresForm" #formElement>
        <div class="row g-3">
          <div class="col-12">
            <div class="row g-3">
              <div class="col-sm-4 form-group">
                <label for="tipoRelacaoId" class="form-label">Tipo de Relação com a Entidade superior</label>
                <nz-select formControlName="tipoRelacaoId" nzShowSearch nzAllowClear nzPlaceHolder="Tipo de Relação"
                  nzSize="large" [compareWith]="compareFn "
                  (blur)="onBlur('tipoRelacaoId')"
                  (ngModelChange)="onChange('tipoRelacaoId')"
                  >
                  <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoRelacao" *ngFor="let item of tipoRelacaoList"
                   />
                </nz-select>
              </div>
              
              <ng-container *ngIf="!isOrganizacao">
                <div class="col-sm-2 form-group" *ngIf="isShowDataAssociacao">
                  <label for="dataAssociacao" class="form-label">Data Associação</label>
                  <nz-date-picker id="dataAssociacao" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
                    formControlName="dataAssociacao" (input)="onInputDateChange($event, 'dataAssociacao')"
                    [nzAllowClear]="true"></nz-date-picker>
                </div>

                <div class="col-sm-2 form-group" *ngIf="isShowDataDesassociacao">
                  <label for="dataDesassociacao" class="form-label">Data Desassociação</label>
                  <nz-date-picker id="dataDesassociacao" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
                    formControlName="dataDesassociacao" (input)="onInputDateChange($event, 'dataDesassociacao')"
                    [nzAllowClear]="true"></nz-date-picker>
                </div>
              </ng-container>

              <div class="col-sm-12 form-group">
                <label for="idEntidadeSuperior" class="form-label">Entidade superior</label>
                <nz-select formControlName="idEntidadeSuperior" [nzMode]="'default'" nzShowSearch nzAllowClear
                  nzPlaceHolder="Entidade superior" nzSize="large" [compareWith]="compareFn">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of entidadeSuperiorListFiltrado">
                  </nz-option>
                </nz-select>
              </div>

              <div class="col-sm-12 form-group my-2" *ngIf="desvincular || editar">
                <label for="justificativa" class="form-label">Justificativa</label>
                <nz-input-group nzSize="large">
                  <input nz-input id="justificativa" formControlName="justificativa" placeholder="Justificativa" />
                </nz-input-group>
              </div>

              <div class="col-12 d-flex justify-content-end align-items-end">
                <button nz-button nzType="primary" nzSize="large" type="button" (click)="submit()">
                  {{ textoBotao() }}
                </button>

                <button nz-button nzType="default" nzSize="large" type="button" class="ms-3" (click)="reset()">
                  Limpar
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-container>
  <div class="col-12 mt-4">
    <div class="d-flex flex-column page-content border border-radius w-100">
      <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
        (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate"
        [nzScroll]="{ x: 'max-content' }">
        <thead>
          <tr>
            <th nzColumnKey="nomeReduzido" nzWidth="150px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">Nome Reduzido</th>
            <th nzColumnKey="nome" nzWidth="250px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">Nome</th>
            <th nzColumnKey="cnpj" nzWidth="130px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">CNPJ</th>
            <th nzColumnKey="nomeTipoRelacao" nzWidth="110px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">Tipo Relação</th>
            <th nzColumnKey="dataCadastro" nzWidth="120px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">Data Cadastro</th>
            <th nzColumnKey="status" nzWidth="100px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">Status</th>
            <th nzColumnKey="dataAssociacao" nzWidth="120px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">
              Data Associação
            </th>
            <th nzColumnKey="dataDesassociacao" nzWidth="120px" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">
              Data Desassociação
            </th>
            <th nzColumnKey="justificativa" nzWidth="80px" class="text-center" [nzShowSort]="isEdicao()" [nzSortFn]="isEdicao()">
              Justificativa
            </th>
            <ng-container *ngIf="!somenteVisualizar">
              <th nzColumnKey="acoes" nzWidth="80px" [nzRight]="true">Ações</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dataSet; let i = index">
            <td>
              {{ nomeReduzidoLinha(item) }}
            </td>
            <td>
              {{ nomeLinha(item) }}
            </td>
            <td>
              {{ cnpjLinha(item) | cnpj }}
            </td>
            <td>
              {{ tipoRelacaoLinha(item) }}
            </td>
            <td>{{ item?.dataCadastro | brDate }}</td>
            <td>{{ idParams ? item?.status : "Ativo" }}</td>
            <td>{{ item?.dataAssociacao | brDate }}</td>
            <td>{{ item?.dataDesassociacao | brDate }}</td>
            <td class="text-center">
              <span nz-icon nzType="info-circle" nzTheme="outline" nz-popover [nzPopoverContent]="item?.justificativa"
                nzPopoverPlacement="top" *ngIf="item?.justificativa"></span>
            </td>
            <ng-container *ngIf="!somenteVisualizar">
            <td class="text-center" [nzRight]="true">
                <ng-container *ngIf="esconderBotaoItemDesassociado(item) || esconderBotaoRemover(item)">
                  <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                    <span nz-icon nzType="more" nzTheme="outline"></span>
                  </button>
                </ng-container>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <ng-container *ngIf="esconderBotaoItemDesassociado(item)">
                      <li nz-menu-item type="button" (click)="editarItem(item, i)">
                        <a> Editar</a>
                      </li>
                      <li nz-menu-item type="button" (click)="desassociarItem(item)">
                        <a> Desvincular </a>
                      </li>
                    </ng-container>
                    <li nz-menu-item type="button" (click)="removerItem(item)" *ngIf="esconderBotaoRemover(item)">
                      <a> Remover</a>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #footerTemplate>
        <section class="d-flex justify-content-end w-100">
          <app-pagination [itemPorPagina]="10"></app-pagination>
        </section>
      </ng-template>
      <ng-template #semDadosTemplate>
        <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
          <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
        </div>
      </ng-template>
    </div>
  </div>
</div>
